export default __webpack_public_path__ + "7b252094e2f05c6287919a430c270959.svg";